import './styles.scss';

import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import ImmersiveAppBar from '../../components/appbar/appbar';
import ImmersiveFooter from '../../components/footer/footer';

interface LegalDocumentPageProps {
  markdown: string;
  onBack: () => void;
}

function LegalDocumentPage({ markdown, onBack }: LegalDocumentPageProps) {
  return (
    <>
      <ImmersiveAppBar />
      <div className="terms-of-use-container">
        <div className="content">
          <div className="legal-markdown">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
          </div>

          <Button className="back-button" variant="outlined" onClick={onBack}>
            <FontAwesomeIcon icon={faChevronLeft} />
            <span>Go back</span>
          </Button>
        </div>
      </div>
      <ImmersiveFooter renderConnectionStatus={false} />
    </>
  );
}

export default LegalDocumentPage;
